<template>
    <div class="content conmon-top">
        <el-row class="cheat-manage-top">
            <el-col class="cheat-message">
                使用方法：在需要中奖的微信里向本公众号发送“cheat 86 获奖等级 备注”（参数分别是：cheat 活动id 兑奖密码 获奖等级 备注，当没有设置兑奖密码时，可去掉此参数），比如想让王局长获得
                一等奖那么就用王局长的手机发送“cheat 86 1 王局长”，收集好信息后，王局长在抽奖的时候就会中奖了
            </el-col>
        </el-row>
        <el-row class="import-data-title" style="margin-top: 10px">
            <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    class="table">
                <el-table-column
                        prop="wecha_id"
                        label="open id"
                        width=" ">
                </el-table-column>
                <el-table-column
                        prop="prizetype"
                        label="奖项"
                        width="250">
                </el-table-column>
                <el-table-column
                        prop="intro"
                        label="备注"
                        width="250">
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="250"
                        style="display: flex;justify-content: center">
                    <template slot-scope="scope">
                        <div class="op-link" style="margin:0 10px;">
                            <span @click="deleteAction(scope.row.id)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-foot">
                <el-pagination
                        class="table-foot-pagination"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-size="limit"
                        layout="total, prev, pager, next, jumper"
                        :total="totalCount">
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>
<script>
import { cheatActivity, deleteCheatActivity } from '@/api/customer.js'
export default {
  name: 'cheat-manage',
  data () {
    return {
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0
    }
  },
  methods: {
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.load()
    },
    handleCurrentChange(page) {
      this.page = page
      this.load()
    },
    load() {
      let id = this.$route.query.id
      cheatActivity(id, this.page).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.records
          this.totalCount = res.data.data.total
        }
      })
    },
    deleteAction(id) {
      this.$confirm('确认删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCheatActivity(id).then((res) => {
          if (res.data.code === 0) {
            this.load()
            _g.toastMsg('success', '删除数据成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
      })
    }
  },
  created() {
    this.load()
  },
  components: {
  }
}
</script>

<style scoped>
    .cheat-manage-top{
        background-color: #fefbe4;
        border:1px solid #f3ecb9;
        color:#993300;
        margin-bottom: 5px;
        padding:5px;
    }
    .cheat-message{
        text-align: left;
        padding:0 10px;
    }
</style>
